import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { RydeUiUnit, useOpenRelatedEntitiesDrawer } from "@ryde/shared";

import { EditFormFooterButton } from "../../../../right";
import { RELATED_ENTITIES_HEADER_ICON_SIZE_PX } from "./related-entities.constants";
import { RelatedEntitiesErrorButtonStyled } from "./related-entities.styled";
import { getShowRelatedEntitiesTooltipText } from "./related-entities.utils";

interface IRelatedEntitiesErrorButton {
  entity: RydeUiUnit;
  entityId?: number;
  entityLabel?: string;
}

export const RelatedEntitiesErrorButton: FC<IRelatedEntitiesErrorButton> = ({
  entity,
  entityId,
  entityLabel,
}) => {
  const { t } = useTranslation();
  const { openRelatedEntitiesDrawer, isEntityRelationsSupported } =
    useOpenRelatedEntitiesDrawer();

  const handleClick = useEvent(() => {
    openRelatedEntitiesDrawer({ entity, entityId, entityLabel });
  });

  if (!entityId || !isEntityRelationsSupported(entity)) {
    return null;
  }

  return (
    <RelatedEntitiesErrorButtonStyled>
      <EditFormFooterButton type="button" onClick={handleClick}>
        <AccountTreeOutlinedIcon
          style={{ fontSize: `${RELATED_ENTITIES_HEADER_ICON_SIZE_PX}px` }}
        />
        <span>
          {getShowRelatedEntitiesTooltipText({ t, entity, entityId })}
        </span>
      </EditFormFooterButton>
    </RelatedEntitiesErrorButtonStyled>
  );
};
